import { render, staticRenderFns } from "./ResDepartment.vue?vue&type=template&id=d882403e&scoped=true&"
import script from "./ResDepartment.vue?vue&type=script&lang=js&"
export * from "./ResDepartment.vue?vue&type=script&lang=js&"
import style0 from "./ResDepartment.vue?vue&type=style&index=0&id=d882403e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d882403e",
  null
  
)

export default component.exports